<template>
	<div class="slider-wrapper">
		<ja-budget-slider-legend v-if="useLegend" class="mb--2" />
		<div class="slider-info">
			<label class="heading-4 slider-name"> {{ $t(title) }} </label>
		</div>
		<div class="slider-container">
			<ja-budget-slider
				v-model="value"
				:name="name"
				:min="min"
				:max="max"
				:budget="remainingBudget"
				:recommended-min="recommendedMin"
				:recommended-max="recommendedMax"
				:step="1"
				block-slider
				class="budget-slider"
			>
			</ja-budget-slider>
			<ja-currency-input
				v-model="value"
				:aria-label="$t('amountSaveCategory', { category: name })"
				class="budget-input"
				:max="max"
				:aria-value-max="max"
			>
			</ja-currency-input>
		</div>
		<div v-if="useMessages" class="message">
			<span v-show="value < recommendedMin" class="message--min-color">
				{{ $t('sliderMinMsg') }}
			</span>
			<span v-show="value > recommendedMax" class="message--max-color">
				{{ $t('sliderMaxMsg') }}
			</span>
		</div>
	</div>
</template>

<script>
import BudgetSlider from '@/components/LifeStageIntro/elements/BudgetSlider';
import BudgetSliderLegend from '@/components/LifeStageIntro/elements/BudgetSliderLegend';
import { CurrencyInput } from '@/components/ui';
export default {
	components: {
		jaBudgetSlider: BudgetSlider,
		jaCurrencyInput: CurrencyInput,
		jaBudgetSliderLegend: BudgetSliderLegend
	},
	props: {
		name: {
			type: String,
			default: ''
		},
		range: {
			type: Array,
			default: () => [0, 1]
		},
		recommendedRange: {
			type: Array,
			default: () => [0, 1]
		},
		title: {
			type: String,
			default: 'setBudget'
		},
		useMessages: {
			type: Boolean,
			default: true
		},
		initialValue: {
			type: Number,
			default: 0
		},
		useLegend: {
			type: Boolean,
			default: true
		},
		remainingBudget: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			min: this.range[0],
			max: this.range[1],
			recommendedMin: this.recommendedRange[0],
			recommendedMax: this.recommendedRange[1],
			value: this.initialValue || 0
		};
	},
	watch: {
		value(val) {
			// TODO: Throttle this as it fires too many events
			// especially when slider is moved
			this.$emit('valueChanged', val);
		}
	},
	methods: {
		validationClasses() {},
		onSavingSliderChanged() {}
	}
};
</script>

<style lang="scss" scoped>
.slider-wrapper {
	width: 100%;
	background-color: $page-bgcolor;
	padding: 32px;
	border-radius: 8px;

	.slider-container {
		display: flex;
	}

	.slider-info {
		margin-bottom: 16px;
	}

	.budget-slider {
		flex-grow: 1;
	}

	.budget-input {
		margin-left: 16px;
		margin-top: -8px;
		width: 80px;
	}

	.message {
		display: flex;
		justify-content: flex-end;
		margin-top: 8px;
		font-family: 'RobotoRegular';
		min-height: 24px;

		&--min-color {
			color: $budget-min-color;
		}

		&--max-color {
			color: $budget-max-color;
		}
	}
}
</style>
